import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'us5.datadoghq.com',
    service: 'streamline',
    env: process.env.REACT_APP_DATADOG_ENV_TAG,
    forwardErrorsToLogs: false,
    sessionSampleRate: 100,
  });
}

if (process.env.REACT_APP_DATADOG_CLIENT_TOKEN && process.env.REACT_APP_DATADOG_RUM_APP_ID) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'us5.datadoghq.com',
    env: process.env.REACT_APP_DATADOG_ENV_TAG,
    service: 'streamline',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    startSessionReplayRecordingManually: true,
  });
}
